module.exports = __webpack_public_path__ + "img/Z60Q_17.35f52c43.jpg";